import { ExtractedItemAnswer } from "@zitelab/ionic-fhir-questionnaires";

export const calculateWho5 = (answers: {
  [key: string]: ExtractedItemAnswer;
}): { score: number; color: string } => {
  const relevantLinkIds = [
    "feltHappy",
    "feltCalm",
    "feltActive",
    "feltFresh",
    "interestingDays"
  ];
  const overallScore = Object.values(answers)
    .filter(answer => relevantLinkIds.includes(answer.linkId))
    .reduce((acc, answer) => {
      const scoreDict = {
        ALWAYS: 5,
        MOST_OF_THE_TIME: 4,
        MORE_THAN_HALF_THE_TIME: 3,
        LESS_THAN_HALF_THE_TIME: 2,
        SOMETIMES: 1,
        NEVER: 0,
        NO_ANSWER: 0
      };
      const itemScore = (scoreDict[answer.answer.code] || 0) * 4;
      return acc + itemScore;
    }, 0);
  let colorCode: string;
  if (overallScore <= 35) {
    colorCode = "dashboard-item-red";
  } else if (overallScore > 35 && overallScore <= 50) {
    colorCode = "dashboard-item-yellow";
  } else {
    colorCode = "dashboard-item-green";
  }
  return {
    score: overallScore,
    color: colorCode
  };
};



// WEBPACK FOOTER //
// ./src/app/utils/calculate-who5.ts